export const errorMessages: { [key: string]: string } =  {
  'Too Many Attempts.': 'Too many attempts. Please wait and try again in 1 minute.',
  "You've requested for authorization token too many times. Please wait up to 10 minutes and try again": 'Too many requests. Please wait 10 minutes before requesting a new code.',
}
